<div cdkDropList (cdkDropListDropped)="onQuestionDrop($event)"
     [cdkDropListDisabled]="readonly">
  <div cdkDrag *ngFor="let question of questions; index as i"
       [cdkDragData]="question"
       class="question-container">
    <div class="question-placeholder" *cdkDragPlaceholder></div>
    
    <button mat-flat-button *ngIf="!readonly  && !buttonsIsHide"
        class="add-button"
        [matTooltip]="'Добавить вопрос'"
        (click)="openQuestionCreateDialog(i+1)">
      <mat-icon>add</mat-icon>
    </button>

    <div class="question-wrapper">
      <div class="buttons" *ngIf="!readonly">
        <div class="button" cdkDragHandle
             (click)="openQuestionMoveDialog(question)"
             matTooltip="Переместить вопрос">
          <mat-icon>unfold_more</mat-icon>
        </div>
      </div>
      <app-question-edit-form
        class="question"
        [readonly]="readonly"
        [index]="i"
        [testId]="testId"
        [testType]="testType"
        [question]="question"
        (delete)="onQuestionDelete(question)"></app-question-edit-form>
    </div>
    <div *cdkDragPreview class="question-preview">
      <div class="number">{{i + 1}}.</div>
      <div class="text">{{question.text}}</div>
    </div>
  </div>
</div>

<button mat-flat-button *ngIf="!readonly"
        class="add-button"
        [matTooltip]="'Добавить вопрос'"
        (click)="openQuestionCreateDialog(questions.length+1)"> 
  <mat-icon>add</mat-icon>
</button>


<button mat-fab *ngIf="!readonly  && buttonsIsHide"
        class="show-buttons"
        color="primary"
        [matTooltip]="'Показать кнопки'"
        (click)="setHideButtons(false)"> 
  <mat-icon>add_circle_outline</mat-icon>
</button>
<button mat-fab *ngIf="!readonly && !buttonsIsHide"
        class="hide-buttons"
        [matTooltip]="'Скрыть кнопки'"
        (click)="setHideButtons(true)"> 
  <mat-icon>highlight_off</mat-icon>
</button>